import {
  CSSProperties,
  FC,
  Fragment,
  PropsWithChildren,
  ReactNode,
  useMemo,
} from 'react';
import {
  DataObjectGroupWithDescriptionsDto,
  isObjectWith,
  SampleDataObjectValidFormDataType,
  Tooltip,
} from '@atlas-frontend/sdk';
import { useSampleContext } from '../state/SampleContext';

interface TooltipForSomeProps extends PropsWithChildren {
  sampleDataObjects: SampleDataObjectValidFormDataType[];
}

export const TooltipForSome: FC<TooltipForSomeProps> = (props) => {
  const { sampleDataObjects, children } = props;
  const { groupOrDescription } = useSampleContext();

  const descriptions = (
    groupOrDescription as DataObjectGroupWithDescriptionsDto
  )?.descriptions;

  const tooltip = useMemo(
    () =>
      (descriptions || [])
        .filter(({ id }) =>
          sampleDataObjects.some(
            (o) => o.dataObjectDescriptionId === id && o.isLocked,
          ),
        )
        .map(({ name, code }, index) => (
          <Fragment key={code}>
            {index ? <br /> : null}
            {`${code} - ${name}`}
          </Fragment>
        )),
    [descriptions, sampleDataObjects],
  );

  /**
   * This due to known issue with antd Icon + Tooltip:
   * https://github.com/ant-design/ant-design/issues/12005
   */
  if (
    isObjectWith(children, { props: {} }) &&
    (!isObjectWith(children.props, { onClick: noop }) ||
      !children.props.onClick)
  ) {
    return (
      <Tooltip title={tooltip} placement="left" wrapperType={InlineWrapper}>
        {children}
      </Tooltip>
    );
  }

  return (
    <Tooltip title={tooltip} wrapperType={InlineWrapper}>
      {children}
    </Tooltip>
  );
};

const noop = () => {
  /*noop*/
};

const InlineWrapper: FC<{
  style?: CSSProperties;
  children: ReactNode;
}> = ({ style, children, ...rest }) => (
  <span
    style={{
      lineHeight: 0,
    }}
    {...rest}
  >
    {children}
  </span>
);
